<template>
  <bottom-sheet>
    <template v-slot:left>
      #{{ number }}
    </template>
    <template v-slot:center>
      <div class="controls">
        <div class="controls__button" :class="{'is-disabled': isFirstStrip}">
          <router-link :to="firstStripURL">
            <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.23 17.771l-5-5 5-5M18.23 17.771l-5-5 5-5" stroke="#231F1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span>First</span>
          </router-link>
        </div>
        <div class="controls__button" :class="{'is-disabled': isLatestStrip}">
          <router-link :to="latestStripURL">
            <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.23 17.771l5-5-5-5M6.23 17.771l5-5-5-5" stroke="#231F1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span>Latest</span>
          </router-link>
        </div>
        <div class="controls__button" :class="{'is-disabled': isFirstStrip}">
          <router-link :to="previousStripURL">
            <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.23 18.771l-6-6 6-6" stroke="#231F1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span>Previous</span>
          </router-link>
        </div>
        <div class="controls__button" :class="{'is-disabled': isLatestStrip}">
          <router-link :to="nextStripURL">
            <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.23 18.771l6-6-6-6" stroke="#231F1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span>Next</span>
          </router-link>
        </div>
      </div>
    </template>
    <template v-slot:right>
      <span v-if="season">
        {{season.name}}
      </span>
      <span v-else>
        No season
      </span>
    </template>
  </bottom-sheet>
</template>

<script>
import { mapGetters } from 'vuex';
import BottomSheet from '../../components/BottomSheet.vue';

export default {
  name: 'Controls',
  components: {
    BottomSheet,
  },
  props: {
    number: Number,
    name: String,
    caption: String,
    publishDate: Object,
    likeCount: Number,
    url: String,
    season: Object,
  },
  computed: {
    ...mapGetters(['getLatestStripNumber']),
    isFirstStrip() {
      return this.number === 1;
    },
    firstStripURL() {
      return this.getURL(1);
    },
    previousStripURL() {
      const previousStrip = Math.max(1, this.number - 1);
      return this.getURL(previousStrip);
    },
    isLatestStrip() {
      return this.number === this.getLatestStripNumber;
    },
    nextStripURL() {
      let nextStrip = this.number + 1;
      if (this.getLatestStripNumber) {
        nextStrip = Math.min(this.getLatestStripNumber, nextStrip);
      }
      return this.getURL(nextStrip);
    },
    latestStripURL() {
      return this.getURL(this.getLatestStripNumber || this.number);
    },
  },
  methods: {
    getURL(stripNumber) {
      return { name: 'Comic', params: { stripNumber } };
    },
  },
};
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  text-align: center;
  @media all and (max-width: 700px) {
    width: 100%;
  }
  &__button {
    &.is-disabled {
      opacity: 0.5;
      pointer-events: none;
    }
    flex: 1;
    @media all and (min-width: 700px) {
      margin: 0 10px;
    }
    a {
      display: block;
      color: var(--color-dark);
      text-align: center;
    }
    svg {
      display: none;
      @media all and (max-width: 700px) {
        display: inline-block;
      }
    }
    span {
      @media all and (max-width: 700px) {
        display: block;
        font-size: var(--font-small);
      }
    }
  }
}
</style>
